<layout>

    <div id="dots" >
        <div  
            *ngFor="let d of questions | slice:1" 
            class="dot" 
            [ngClass]="{    
                current: d.questionID == current.questionID, 
                correct: isCorrect(d.questionID), 
                incorrect: !isCorrect(d.questionID)}" 
            (click)="goto(d.questionID); scrollToQuestion()">{{d.allCorrect}}</div>          
    </div>

    <div *ngFor="let question of questions |slice:1; trackBy:trackBy">
        <question
            *ngIf="question.questionID === current?.questionID"
        [question]="question" [profile]="profile"></question>
    </div>

    
    <div class="navigationButtonContainer">
        <div class="left">
            <button *ngIf="current?.questionID > 1" class="previousButton" (click)="previous();">{{config?.lessonTemplateGoBack}}</button>
        </div>
        <div class=right>
            <button class="nextButton"  (click)="next();">{{getNextButtonTitle()}}</button     >
        </div>
    </div>
</layout>
